module.exports = __webpack_public_path__ + "img/item-4.b653ca0e.png";